module.exports = new __parcel__URL__("slovenia.3ab73242.png").toString();